import { Content } from './multi-input-item.styled';

export const MultiInputItem = (props) => {
  const { className, onChange, name, checked, ...rest } = props;

  const cl = (className ?? '') + ' multi';
  return (
    <Content className={cl} {...rest}>
      <input type="checkbox" onChange={onChange} name={name} checked={checked} />
      <span>{name}</span>
    </Content>
  );
};
